import React from 'react';

// Components
import GeneralInfo from './GeneralInfo';
import ProctoringInfo from './ProctoringInfo';
import Location from './Location';
// import ProfilePhoto from './ProfilePhoto';
// import Activate from './Activate';

class RegisterStep extends React.Component {
  render() {
    switch(this.props.step) {
      case 1:
        return <GeneralInfo nextStep={this.props.nextStep} {...this.props} />;

      case 2:
        return <ProctoringInfo nextStep={this.props.nextStep} {...this.props} />;

      case 3:
        return <Location nextStep={this.props.nextStep} {...this.props} />;

      // case 4:
      //   return <ProfilePhoto nextStep={this.props.nextStep} {...this.props} />;

      // case 5:
      //   return <Activate nextStep={this.props.nextStep} {...this.props} />;

      default:
        return <GeneralInfo nextStep={this.props.nextStep} {...this.props} />;
    }
  }
}

export default RegisterStep;


// WEBPACK FOOTER //
// ./src/app/components/Register/RegisterStep.js